import { type PropsWithChildren } from 'react';

import type { SparklineThresholdProps } from '../types/sparkline-thresholds-props.js';

export const Threshold = (props: PropsWithChildren<SparklineThresholdProps>) =>
  null;
